<!-- Products Section - Fixed for all screen sizes with proper dropdown visibility -->

<!-- Breadcrumb - Commented out as per original -->
<!-- <div class="breadcrumb">
<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">Products</li>
  </ol>
</nav>
</div> -->

<div class="content-info">
  <!-- Header with Title and Search/Add buttons -->
  <!-- Header with Title and Search/Add buttons -->
  <div class="content-title">
    <h3 class="title">Products</h3>
    <div class="title-actions">
      <!-- Consolidated Downloads Dropdown -->
      <div class="dropdown d-inline-block">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="downloadsDropdown" data-bs-toggle="dropdown"
          aria-expanded="false">
          <i class="bi bi-download"></i> Downloads
        </button>

        <ul class="dropdown-menu" aria-labelledby="downloadsDropdown">
          <li>
            <h6 class="dropdown-header">Templates</h6>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="downloadCreationTemplate()">
              For Creation (No SKU)
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="downloadUpdateTemplate()">
              For Update (With SKU)
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="downloadCategoryTemplate()">
              Category Template
            </a>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li>
            <h6 class="dropdown-header">Data Exports</h6>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)"
              (click)="openDownloadConfirmation('CLASSIFICATION', 'Classifications')">
              Classifications (Dept/Cat/SubCat)
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)"
              (click)="openDownloadConfirmation('PRODUCT_MASTER', 'Product/SKU Master')">
              Product/SKU Master
            </a>
          </li>
        </ul>
      </div>

      <!-- Bulk Upload Dropdown -->
      <div class="dropdown d-inline-block">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="bulkUploadDropdown"
          data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-upload"></i> Bulk Upload
        </button>
        <ul class="dropdown-menu" aria-labelledby="bulkUploadDropdown">
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="triggerUpload('CREATE')">
              Bulk Create Products
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="triggerUpload('UPDATE')">
              Bulk Update Products
            </a>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li>
            <a class="dropdown-item" href="javascript:void(0)" (click)="triggerUpload('CATEGORY_CREATE')">
              Bulk Create Categories
            </a>
          </li>
        </ul>
      </div>

      <!-- Hidden File Input -->
      <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".xlsx, .xls" />

      <!-- Search by Name input -->
      <label class="zf-search sm" title="Search by product name">
        <i class="bi bi-search"></i>
        <input type="text" [(ngModel)]="searchName" (input)="onSearchByName()" placeholder="Search by name" />
      </label>

      <!-- Search by SKU Code input -->
      <label class="zf-search sm" style="width: 150px" title="Search by SKU">
        <i class="bi bi-upc"></i>
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="SKU" />
      </label>

      <!-- Add Product button - hidden for AREA_MANAGER -->
      @if (canAddProduct()) {
      <button class="btn btnprimary text-nowrap" [routerLink]="['/add-product']">
        <i class="bi bi-plus-lg"></i> Add Product
      </button>
      <div class="btn-group" role="group" aria-label="Bulk tools">
        <button type="button" class="btn btn-outline-primary text-nowrap" [routerLink]="['/bulk-add-products']"
          title="Key in many SKUs at once on a grid">
          <i class="bi bi-grid-3x3"></i> Bulk Add
        </button>
        <button type="button" class="btn btn-outline-primary text-nowrap" [routerLink]="['/bulk-ean-mapping']"
          title="Tag or replace EAN barcodes on many SKUs at once (no pricing needed)">
          <i class="bi bi-upc-scan"></i> Bulk EAN
        </button>
      </div>
      }
    </div>
  </div>

  <!-- Table Container - Fixed overflow to show dropdowns properly on all screen sizes -->
  <div class="common-table mt-3">
    <!-- Table responsive wrapper with fixed overflow properties -->
    <!-- FIXED: Added max-height for internal scrolling as requested -->
    <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
      <table class="table">
        <thead>
          <tr>
            <th>SKU Code</th>
            <th>Name</th>
            <th>EAN</th>
            <th>Category</th>
            <th>Vendor</th>
            <th>Department</th>
            <th>Brand</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <!-- FIXED: Added min-height to ensure dropdown has enough space even with single row -->
        <tbody style="min-height: 150px">
          <!-- Loading state -->
          <!-- FIXED: Changed colspan from 6 to 8 to match number of columns -->
          @if(productsLoading) {
          <tr>
            <td colspan="9" class="text-center">Loading products…</td>
          </tr>
          } @else {
          <!-- No products found state -->
          <!-- FIXED: Changed colspan from 6 to 8 to match number of columns -->
          @if(!products.length) {
          <tr>
            <td colspan="9"><div class="zf-empty"><strong>No products found</strong><span>Add a product or import a product master to get started.</span></div></td>
          </tr>
          } @else {
          <!-- Product rows loop -->
          @for(product of products; track product.id) {
          <tr>
            <!-- SKU Code column -->
            <td class="zf-key">{{ product.sku || "-" }}</td>
            <!-- Product Name column -->
            <td class="zf-strong">{{ product.longDescription || "-" }}</td>
            <!-- Primary barcode + "price pending" when the SKU has no usable price yet -->
            <td class="text-nowrap zf-mono zf-dim">
              {{ primaryEan(product) || "-" }}
              @if (isPricePending(product)) {
              <span class="zf-status warn ms-1" title="No selling price yet — priced at its first GRN">price pending</span>
              }
            </td>
            <!-- Category column -->
            <td>{{ product?.category?.name || "-" }}</td>
            <!-- Vendor column -->
            <td>{{ product?.vendor?.name || "-" }}</td>
            <!-- Department column -->
            <td>{{ product?.department?.name || "-" }}</td>
            <!-- Brand column -->
            <td>{{ product?.brand?.name || "-" }}</td>
            <!-- Status Toggle column -->
            <td>
              <div class="form-check form-switch d-flex align-items-center gap-2 mb-0">
                <input class="form-check-input" type="checkbox" role="switch" id="statusSwitch-{{ product.id }}"
                  [checked]="product.isActive" (change)="toggleProductStatus(product)" />
                <label class="form-check-label" [for]="'statusSwitch-' + product.id">
                  <span class="zf-status" [class.ok]="product.isActive">{{ product.isActive ? "Active" : "Inactive" }}</span>
                </label>
              </div>
            </td>

            <!-- Action column with dropdown -->
            <td>
              <!-- Fixed-strategy popper: the menu escapes the scrolling table, so it is not clipped on a short list -->
              <div class="dropdown">
                <button class="btn zf-row-menu dropdown-toggle" type="button"
                  id="dropdownMenuButton-{{ product.id }}" data-bs-toggle="dropdown" aria-expanded="false" title="Actions"
                  data-bs-popper-config='{"strategy":"fixed"}'>
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end zf-row-menu-list"
                  [attr.aria-labelledby]="'dropdownMenuButton-' + product.id">
                  <!-- Edit Product option - Hidden for view-only roles -->
                  @if (!isViewOnlyAccess()) {
                  <li>
                    <a class="dropdown-item" [routerLink]="['/edit-product', product.id]"
                      data-bs-target="#addproduct">
                      <i class="bi bi-pencil-square"></i> Edit
                    </a>
                  </li>
                  }

                  <!-- Print Barcode option -->
                  <li>
                    <a class="dropdown-item" (click)="openBarcodePrintModal(product)">
                      <i class="bi bi-qr-code"></i> Print barcode
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          } } }
        </tbody>
      </table>
    </div>

    <!-- Pagination section -->
    <div class="table-pagination">
      <!-- Entries per page selector -->
      <div class="pagination-count">
        <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
        <span>entries per page</span>
      </div>

      <!-- Pagination controls -->
      <ul class="pagination">
        <!-- Previous button -->
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <a class="page-link">&lsaquo;</a>
        </li>

        <!-- First Page button -->
        <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
          <a class="page-link">1</a>
        </li>

        <!-- Left Ellipsis -->
        @if (currentPage > 4) {
        <li class="page-item disabled">
          <a class="page-link">…</a>
        </li>
        }

        <!-- Pages Around Current page -->
        @for (page of getVisiblePages(); track page) {
        <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
          <a class="page-link">{{ page }}</a>
        </li>
        }

        <!-- Right Ellipsis -->
        @if (currentPage < pageCount - 3) { <li class="page-item disabled">
          <a class="page-link">…</a>
          </li>
          }

          <!-- Last Page button - only show if more than 1 page -->
          @if (pageCount > 1) {
          <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
            <a class="page-link">{{ pageCount }}</a>
          </li>
          }

          <!-- Next button -->
          <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
            <a class="page-link">&rsaquo;</a>
          </li>
      </ul>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal Template -->
<ng-template #deleteConfirmationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="confirmDeleteModalLabel">Confirm Delete</h5>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body delete-msg">
    <h3>
      Are you sure you want to delete
      <strong>{{ productToDelete?.name }}</strong> product?
    </h3>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="closeModal()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      Delete
    </button>
  </div>
</ng-template>

<!-- Barcode Print Modal Template - ng-bootstrap version -->
<ng-template #barcodePrintModalContent let-modal>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-dark" id="barcodePrintModalLabel">
          Select Barcode Template
        </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="text-dark">
          Select a template to print the barcode for:
          <strong class="text-dark">{{
            selectedProduct?.longDescription
            }}</strong>
        </p>

        <!-- Template selector -->
        <div class="mb-3">
          <label for="templateSelect" class="form-label text-dark">Template:</label>
          <select class="form-select" id="templateSelect" [(ngModel)]="selectedTemplateId">
            @if(barcodeTemplates.length) { @for(template of barcodeTemplates;
            track template.id) {
            <option [value]="template.id">{{ template.name }}</option>
            } } @else {
            <option value="" disabled>Loading templates...</option>
            }
          </select>
        </div>

        <!-- Quantity input -->
        <div class="mb-3">
          <label for="quantityInput" class="form-label text-dark">Quantity:</label>
          <input type="number" class="form-control" id="quantityInput" min="1" [(ngModel)]="printQuantity" />
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnsecondary" (click)="modal.dismiss('Cancel click')">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" [disabled]="!selectedTemplateId || printQuantity < 1"
          (click)="printBarcode(modal)">
          Print
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Download Confirmation Modal Template -->
<ng-template #downloadConfirmationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadConfirmationModalLabel">Confirm Download</h5>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <h3 class="text-dark">
      Are you sure you want to download <strong>{{ downloadConfirmationName }}</strong> data?
    </h3>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="confirmDownloadAction()">
      Yes, Download
    </button>
  </div>
</ng-template>

<!-- Bulk Upload Preview (dry-run) Modal -->
<ng-template #bulkUploadPreviewModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title" id="bulkUploadPreviewModalLabel">Review Upload</h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="d-flex gap-3 mb-3">
      <span class="badge bg-secondary fs-6">{{ uploadPreview?.totalRows }} rows</span>
      <span class="badge bg-success fs-6">{{ uploadPreview?.validRows }} ready</span>
      @if (uploadPreview?.errorRows > 0) {
      <span class="badge bg-danger fs-6">{{ uploadPreview?.errorRows }} with errors</span>
      }
    </div>

    @if (previewWillCreateAnything()) {
    <div class="alert alert-info">
      <i class="bi bi-magic"></i> The following masters do not exist yet and will be
      <strong>created automatically</strong> with this upload:
      <ul class="mb-0 mt-2">
        @for (name of uploadPreview?.willCreate?.departments; track $index) {
        <li><strong>Department:</strong> {{ name }}</li>
        }
        @for (c of uploadPreview?.willCreate?.categories; track $index) {
        <li><strong>Category:</strong> {{ c.name }} <span class="text-muted">(in {{ c.department }})</span></li>
        }
        @for (s of uploadPreview?.willCreate?.subCategories; track $index) {
        <li><strong>Sub-category:</strong> {{ s.name }} <span class="text-muted">(in {{ s.category }})</span></li>
        }
        @for (name of uploadPreview?.willCreate?.manufacturers; track $index) {
        <li><strong>Manufacturer:</strong> {{ name }}</li>
        }
        @for (b of uploadPreview?.willCreate?.brands; track $index) {
        <li><strong>Brand:</strong> {{ b.name }} <span class="text-muted">(under {{ b.manufacturer }})</span></li>
        }
        @for (l of uploadPreview?.willCreate?.vendorManufacturerLinks; track $index) {
        <li><strong>Vendor–Manufacturer link:</strong> {{ l.vendor }} &harr; {{ l.manufacturer }}</li>
        }
      </ul>
      <div class="mt-2 small text-muted">
        Spot a typo in this list? Cancel, fix the spelling in the file, and upload again.
      </div>
    </div>
    }

    @if (uploadPreview?.errors?.length) {
    <div class="alert alert-danger d-flex justify-content-between align-items-center">
      <div>
        <i class="bi bi-exclamation-octagon-fill"></i> <strong>Nothing will be created until every row is fixed.</strong>
        Correct the rows below in your file, then upload it again.
      </div>
      <button type="button" class="btn btn-sm btn-outline-danger flex-shrink-0 ms-3"
        (click)="exportUploadErrors(uploadPreview?.errors)">
        <i class="bi bi-download"></i> Export Errors
      </button>
    </div>
    <div class="table-responsive" style="max-height: 260px; overflow-y: auto;">
      <table class="table table-sm table-bordered table-hover">
        <thead class="table-light">
          <tr>
            <th>Row</th>
            <th>Column</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          @for (error of uploadPreview?.errors; track $index) {
          <tr>
            <td class="text-center">{{ error.row }}</td>
            <td class="fw-bold">{{ error.column }}</td>
            <td class="text-danger">{{ error.error }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="uploadInProgress">
      Cancel
    </button>
    <button type="button" class="btn btn-success" (click)="confirmBulkUpload(modal)"
      [disabled]="!canCommitUpload()"
      [title]="previewHasErrors() ? 'Fix every row before uploading' : ''">
      @if (uploadInProgress) {
      <span class="spinner-border spinner-border-sm me-1"></span>
      }
      @if (previewHasErrors()) { Fix {{ uploadPreview?.errorRows }} row(s) to continue } @else { Create {{
      uploadPreview?.totalRows }} Products }
    </button>
  </div>
</ng-template>

<!-- Bulk Upload Error Modal -->
<ng-template #bulkUploadErrorModal let-modal>
  <div class="modal-header bg-danger text-white">
    <h5 class="modal-title" id="bulkUploadErrorModalLabel">Bulk Upload Validation Errors</h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="alert alert-warning">
      <i class="bi bi-exclamation-triangle-fill"></i> <strong>No products were created.</strong> Correct the following
      errors in your Excel file and upload it again.
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead class="table-light">
          <tr>
            <th>Sheet</th>
            <th>Row</th>
            <th>Column</th>
            <th>Error Message</th>
          </tr>
        </thead>
        <tbody>
          @for (error of bulkUploadErrors; track $index) {
          <tr>
            <td>{{ error.sheet }}</td>
            <td class="text-center">{{ error.row }}</td>
            <td class="fw-bold">{{ error.column }}</td>
            <td class="text-danger">{{ error.error }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="exportUploadErrors(bulkUploadErrors)">
      <i class="bi bi-download"></i> Export Errors to Excel
    </button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>